var countryData = [{
  "code": "AFG",
  "cnName": "阿富汗",
  "cnSpell": "AFUHAN",
  "enName": "Afghanistan",
  "hot": false
}, {
  "code": "AGO",
  "cnName": "安哥拉",
  "cnSpell": "ANGELA",
  "enName": "ANGOLA",
  "hot": false
}, {
  "code": "ALB",
  "cnName": "阿尔巴尼亚",
  "cnSpell": "AERBANIYA",
  "enName": "Albania",
  "hot": false
}, {
  "code": "AND",
  "cnName": "安道尔",
  "cnSpell": "ANDAOER",
  "enName": "Andorra",
  "hot": false
}, {
  "code": "ARE",
  "cnName": "阿拉伯联合酋长国",
  "cnSpell": "ALABOLIANHEQIUCHANGGUO",
  "enName": "United Arab Emirates",
  "hot": false
}, {
  "code": "ARG",
  "cnName": "阿根廷",
  "cnSpell": "AGENTING",
  "enName": "ARGENTINA",
  "hot": false
}, {
  "code": "ARM",
  "cnName": "亚美尼亚",
  "cnSpell": "YAMEINIYA",
  "enName": "Armenia",
  "hot": false
}, {
  "code": "ATF",
  "cnName": "法属南部领土",
  "cnSpell": "FASHUNANBULINGTU",
  "enName": "FRENCH SOUTHERN TERRITORIES",
  "hot": false
}, {
  "code": "AUS",
  "cnName": "澳大利亚",
  "cnSpell": "AODALIYA",
  "enName": "AUSTRALIA",
  "hot": true
}, {
  "code": "AUT",
  "cnName": "奥地利",
  "cnSpell": "AODILI",
  "enName": "AUSTRIA",
  "hot": false
}, {
  "code": "BDI",
  "cnName": "布隆迪",
  "cnSpell": "BULONGDI",
  "enName": "BURUNDI",
  "hot": false
}, {
  "code": "BEL",
  "cnName": "比利时",
  "cnSpell": "BILISHI",
  "enName": "BELGIUM",
  "hot": false
}, {
  "code": "BEN",
  "cnName": "贝宁",
  "cnSpell": "BEINING",
  "enName": "BENIN",
  "hot": false
}, {
  "code": "BFA",
  "cnName": "布基纳法索",
  "cnSpell": "BUJINAFASUO",
  "enName": "BURKINA FASO",
  "hot": false
}, {
  "code": "BGD",
  "cnName": "孟加拉国",
  "cnSpell": "MENGJIALAGUO",
  "enName": "BANGLADESH",
  "hot": false
}, {
  "code": "BGR",
  "cnName": "保加利亚",
  "cnSpell": "BAOJIALIYA",
  "enName": "BULGARIA",
  "hot": false
}, {
  "code": "BHR",
  "cnName": "巴林",
  "cnSpell": "BALIN",
  "enName": "BAHRAIN",
  "hot": false
}, {
  "code": "BHS",
  "cnName": "巴哈马",
  "cnSpell": "BAHAMA",
  "enName": "BAHAMAS",
  "hot": false
}, {
  "code": "BLZ",
  "cnName": "伯利兹",
  "cnSpell": "BOLIZI",
  "enName": "BELIZE",
  "hot": false
}, {
  "code": "BMU",
  "cnName": "百慕大",
  "cnSpell": "BAIMUDA",
  "enName": "BERMUDA",
  "hot": false
}, {
  "code": "BRA",
  "cnName": "巴西",
  "cnSpell": "BAXI",
  "enName": "BRAZIL",
  "hot": true
}, {
  "code": "BRB",
  "cnName": "巴巴多斯",
  "cnSpell": "BABADUOSI",
  "enName": "BARBADOS",
  "hot": false
}, {
  "code": "BRN",
  "cnName": "文莱",
  "cnSpell": "WENLAI",
  "enName": "BRUNEI",
  "hot": false
}, {
  "code": "BTN",
  "cnName": "不丹",
  "cnSpell": "BUDAN",
  "enName": "BHUTAN",
  "hot": false
}, {
  "code": "BVT",
  "cnName": "布维岛",
  "cnSpell": "BUWEIDAO",
  "enName": "BOUVET ISLAND",
  "hot": false
}, {
  "code": "BWA",
  "cnName": "博茨瓦纳",
  "cnSpell": "BOCIWANA",
  "enName": "BOTSWANA",
  "hot": false
}, {
  "code": "CAN",
  "cnName": "加拿大",
  "cnSpell": "JIANADA",
  "enName": "Canada",
  "hot": true
}, {
  "code": "CHE",
  "cnName": "瑞士",
  "cnSpell": "RUISHI",
  "enName": "SWITZERLAND",
  "hot": false
}, {
  "code": "CHL",
  "cnName": "智利",
  "cnSpell": "ZHILI",
  "enName": "CHILE",
  "hot": false
}, {
  "code": "CHN",
  "cnName": "中国",
  "cnSpell": "ZHONGGUO",
  "enName": "CHINA",
  "hot": true
}, {
  "code": "CMR",
  "cnName": "喀麦隆",
  "cnSpell": "KAMAILONG",
  "enName": "CAMEROON",
  "hot": false
}, {
  "code": "COG",
  "cnName": "刚果",
  "cnSpell": "GANGGUO",
  "enName": "CONGO",
  "hot": false
}, {
  "code": "COK",
  "cnName": "库克群岛",
  "cnSpell": "KUKEQUNDAO",
  "enName": "COOK ISLANDS",
  "hot": false
}, {
  "code": "COL",
  "cnName": "哥伦比亚",
  "cnSpell": "GELUNBIYA",
  "enName": "COLOMBIA",
  "hot": false
}, {
  "code": "COM",
  "cnName": "科摩罗",
  "cnSpell": "KEMOLUO",
  "enName": "COMOROS",
  "hot": false
}, {
  "code": "CRI",
  "cnName": "哥斯达黎加",
  "cnSpell": "GESIDALIJIA",
  "enName": "COSTA RICA",
  "hot": false
}, {
  "code": "CSR",
  "cnName": "圣诞岛",
  "cnSpell": "SHENGDANDAO",
  "enName": "CHRISTMAS ISLAND",
  "hot": false
}, {
  "code": "CUB",
  "cnName": "古巴",
  "cnSpell": "GUBA",
  "enName": "CUBA",
  "hot": false
}, {
  "code": "CYM",
  "cnName": "开曼群岛",
  "cnSpell": "KAIMANQUNDAO",
  "enName": "CAYMAN ISLANDS",
  "hot": false
}, {
  "code": "CYP",
  "cnName": "塞浦路斯",
  "cnSpell": "SAIPULUSI",
  "enName": "CYPRUS",
  "hot": false
}, {
  "code": "DEU",
  "cnName": "德国",
  "cnSpell": "DEGUO",
  "enName": "GERMANY",
  "hot": true
}, {
  "code": "DJI",
  "cnName": "吉布提",
  "cnSpell": "JIBUTI",
  "enName": "DJIBOUTI",
  "hot": false
}, {
  "code": "DMA",
  "cnName": "多米尼克",
  "cnSpell": "DUOMINIKE",
  "enName": "DOMINICA",
  "hot": false
}, {
  "code": "DNK",
  "cnName": "丹麦",
  "cnSpell": "DANMAI",
  "enName": "DENMARK",
  "hot": false
}, {
  "code": "DZA",
  "cnName": "阿尔及利亚",
  "cnSpell": "AERJILIYA",
  "enName": "ALGERIA",
  "hot": false
}, {
  "code": "ECU",
  "cnName": "厄瓜多尔",
  "cnSpell": "EGUADUOER",
  "enName": "ECUADOR",
  "hot": false
}, {
  "code": "EGY",
  "cnName": "埃及",
  "cnSpell": "AIJI",
  "enName": "EGYPT",
  "hot": false
}, {
  "code": "ESH",
  "cnName": "西撒哈拉",
  "cnSpell": "XISAHALA",
  "enName": "WESTERN SAHARA ",
  "hot": false
}, {
  "code": "ESP",
  "cnName": "西班牙",
  "cnSpell": "XIBANYA",
  "enName": "SPAIN",
  "hot": true
}, {
  "code": "EST",
  "cnName": "爱沙尼亚",
  "cnSpell": "AISHANIYA",
  "enName": "ESTONIA",
  "hot": false
}, {
  "code": "ETH",
  "cnName": "埃塞俄比亚",
  "cnSpell": "AISAIEBIYA",
  "enName": "ETHIOPIA",
  "hot": false
}, {
  "code": "FIN",
  "cnName": "芬兰",
  "cnSpell": "FENLAN",
  "enName": "FINLAND",
  "hot": false
}, {
  "code": "FJI",
  "cnName": "斐济",
  "cnSpell": "FEIJI",
  "enName": "FIJI",
  "hot": false
}, {
  "code": "FRA",
  "cnName": "法国",
  "cnSpell": "FAGUO",
  "enName": "FRANCE",
  "hot": true
}, {
  "code": "FSM",
  "cnName": "密克罗尼西亚",
  "cnSpell": "MIKELUONIXIYA",
  "enName": "MICRONESIA",
  "hot": false
}, {
  "code": "GAB",
  "cnName": "加蓬",
  "cnSpell": "JIAPENG",
  "enName": "GABON",
  "hot": false
}, {
  "code": "GBR",
  "cnName": "英国",
  "cnSpell": "YINGGUO",
  "enName": "UNITED KINGDOM",
  "hot": true
}, {
  "code": "GEO",
  "cnName": "格鲁吉亚",
  "cnSpell": "GELUJIYA",
  "enName": "GEORGIA",
  "hot": false
}, {
  "code": "GHA",
  "cnName": "加纳",
  "cnSpell": "JIANA",
  "enName": "GHANA",
  "hot": false
}, {
  "code": "GIB",
  "cnName": "直布罗陀",
  "cnSpell": "ZHIBULUOTUO",
  "enName": "GIBRALTAR",
  "hot": false
}, {
  "code": "GIN",
  "cnName": "几内亚",
  "cnSpell": "JINEIYA",
  "enName": "GUINEA ",
  "hot": false
}, {
  "code": "GLP",
  "cnName": "瓜德罗普",
  "cnSpell": "GUADELUOPU",
  "enName": "GUADELOUPE",
  "hot": false
}, {
  "code": "GMB",
  "cnName": "冈比亚",
  "cnSpell": "GANGBIYA",
  "enName": "GAMBIA",
  "hot": false
}, {
  "code": "GNB",
  "cnName": "几内亚比绍",
  "cnSpell": "JINEIYABISHAO",
  "enName": "GUINEA BISSAU",
  "hot": false
}, {
  "code": "GNQ",
  "cnName": "赤道几内亚",
  "cnSpell": "CHIDAOJINEIYA",
  "enName": "EQUATORIAL GUINEA ",
  "hot": false
}, {
  "code": "GRC",
  "cnName": "希腊",
  "cnSpell": "XILA",
  "enName": "GREECE",
  "hot": false
}, {
  "code": "GRD",
  "cnName": "格林纳达",
  "cnSpell": "GELINNADA",
  "enName": "GRENADA",
  "hot": false
}, {
  "code": "GRL",
  "cnName": "格陵兰",
  "cnSpell": "GELINGLAN",
  "enName": "GREENLAND",
  "hot": false
}, {
  "code": "GTM",
  "cnName": "危地马拉",
  "cnSpell": "WEIDIMALA",
  "enName": "GUATEMALA",
  "hot": false
}, {
  "code": "GUF",
  "cnName": "法属圭亚那",
  "cnSpell": "FASHUGUIYANA",
  "enName": "FRENCH GUIANA",
  "hot": false
}, {
  "code": "GUM",
  "cnName": "关岛",
  "cnSpell": "GUANDAO",
  "enName": "GUAM",
  "hot": false
}, {
  "code": "GUY",
  "cnName": "圭亚那",
  "cnSpell": "GUIYANA",
  "enName": "GUYANA （BRITISH）",
  "hot": false
}, {
  "code": "HMD",
  "cnName": "赫德岛和麦克唐纳岛",
  "cnSpell": "HEDEDAOHEMAIKETANGNADAO",
  "enName": "HEARD ISLAND AND MCDONALD ISLANDS",
  "hot": false
}, {
  "code": "HND",
  "cnName": "洪都拉斯",
  "cnSpell": "HONGDULASI",
  "enName": "HONDURAS",
  "hot": false
}, {
  "code": "HRV",
  "cnName": "克罗地亚",
  "cnSpell": "KELUODIYA",
  "enName": "CROATIA",
  "hot": false
}, {
  "code": "HTI",
  "cnName": "海地",
  "cnSpell": "HAIDI",
  "enName": "HAITI",
  "hot": false
}, {
  "code": "HUN",
  "cnName": "匈牙利",
  "cnSpell": "XIONGYALI",
  "enName": "HUNGARY",
  "hot": false
}, {
  "code": "IDN",
  "cnName": "印度尼西亚",
  "cnSpell": "YINDUNIXIYA",
  "enName": "INDONESIA",
  "hot": true
}, {
  "code": "IND",
  "cnName": "印度",
  "cnSpell": "YINDU",
  "enName": "INDIA",
  "hot": false
}, {
  "code": "INE",
  "cnName": "尼维斯岛",
  "cnSpell": "NIWEISIDAO",
  "enName": "NEVIS",
  "hot": false
}, {
  "code": "IRL",
  "cnName": "爱尔兰",
  "cnSpell": "AIERLAN",
  "enName": "IRELAND",
  "hot": false
}, {
  "code": "IRN",
  "cnName": "伊朗",
  "cnSpell": "YILANG",
  "enName": "IRAN （ISLAMIC REPUBLIC OF）",
  "hot": false
}, {
  "code": "IRQ",
  "cnName": "伊拉克",
  "cnSpell": "YILAKE",
  "enName": "IRAQ",
  "hot": false
}, {
  "code": "ISL",
  "cnName": "冰岛",
  "cnSpell": "BINGDAO",
  "enName": "ICELAND",
  "hot": false
}, {
  "code": "ISR",
  "cnName": "以色列",
  "cnSpell": "YISELIE",
  "enName": "ISRAEL",
  "hot": false
}, {
  "code": "ITA",
  "cnName": "意大利",
  "cnSpell": "YIDALI",
  "enName": "ITALY",
  "hot": true
}, {
  "code": "JAM",
  "cnName": "牙买加",
  "cnSpell": "YAMAIJIA",
  "enName": "JAMAICA",
  "hot": false
}, {
  "code": "JOR",
  "cnName": "约旦",
  "cnSpell": "YUEDAN",
  "enName": "JORDAN",
  "hot": false
}, {
  "code": "JPN",
  "cnName": "日本",
  "cnSpell": "RIBEN",
  "enName": "JAPAN",
  "hot": true
}, {
  "code": "KAZ",
  "cnName": "哈萨克斯坦",
  "cnSpell": "HASAKESITAN",
  "enName": "KAZAKHSTAN",
  "hot": false
}, {
  "code": "KEN",
  "cnName": "肯尼亚",
  "cnSpell": "KENNIYA",
  "enName": "KENYA",
  "hot": false
}, {
  "code": "KGZ",
  "cnName": "吉尔吉斯斯坦",
  "cnSpell": "JIERJISISITAN",
  "enName": "KYRGYZSTAN",
  "hot": false
}, {
  "code": "KHM",
  "cnName": "柬埔寨",
  "cnSpell": "JIANPUZHAI",
  "enName": "CAMBODIA",
  "hot": false
}, {
  "code": "KOR",
  "cnName": "韩国",
  "cnSpell": "HANGUO",
  "enName": "SOUTH KOREA",
  "hot": true
}, {
  "code": "KWT",
  "cnName": "科威特",
  "cnSpell": "KEWEITE",
  "enName": "KUWAIT",
  "hot": false
}, {
  "code": "LAO",
  "cnName": "老挝",
  "cnSpell": "LAOWO",
  "enName": "LAOS",
  "hot": false
}, {
  "code": "LBN",
  "cnName": "黎巴嫩",
  "cnSpell": "LIBANEN",
  "enName": "LEBANON",
  "hot": false
}, {
  "code": "LBR",
  "cnName": "利比里亚",
  "cnSpell": "LIBILIYA",
  "enName": "LIBERIA",
  "hot": false
}, {
  "code": "LBY",
  "cnName": "利比亚",
  "cnSpell": "LIBIYA",
  "enName": "LIBYA",
  "hot": false
}, {
  "code": "LCA",
  "cnName": "圣卢西亚",
  "cnSpell": "SHENGLUXIYA",
  "enName": "ST. LUCIA",
  "hot": false
}, {
  "code": "LIE",
  "cnName": "列支敦士登",
  "cnSpell": "LIEZHIDUNSHIDENG",
  "enName": "LIECHTENSTEIN",
  "hot": false
}, {
  "code": "LKA",
  "cnName": "斯里兰卡",
  "cnSpell": "SILILANKA",
  "enName": "SRI LANKA",
  "hot": false
}, {
  "code": "LSO",
  "cnName": "莱索托",
  "cnSpell": "LAISUOTUO",
  "enName": "LESOTHO",
  "hot": false
}, {
  "code": "LTU",
  "cnName": "立陶宛",
  "cnSpell": "LITAOWAN",
  "enName": "LITHUANIA",
  "hot": false
}, {
  "code": "LUX",
  "cnName": "卢森堡",
  "cnSpell": "LUSENBAO",
  "enName": "LUXEMBOURG",
  "hot": false
}, {
  "code": "LVA",
  "cnName": "拉脱维亚",
  "cnSpell": "LATUOWEIYA",
  "enName": "LATVIA",
  "hot": false
}, {
  "code": "MAR",
  "cnName": "摩洛哥",
  "cnSpell": "MOLUOGE",
  "enName": "MOROCCO",
  "hot": false
}, {
  "code": "MCO",
  "cnName": "摩纳哥",
  "cnSpell": "MONAGE",
  "enName": "MONACO",
  "hot": false
}, {
  "code": "MDA",
  "cnName": "摩尔多瓦",
  "cnSpell": "MOERDUOWA",
  "enName": "MOLDOVA",
  "hot": false
}, {
  "code": "MDG",
  "cnName": "马达加斯加",
  "cnSpell": "MADAJIASIJIA",
  "enName": "MADAGASCAR",
  "hot": false
}, {
  "code": "MDV",
  "cnName": "马尔代夫",
  "cnSpell": "MAERDAIFU",
  "enName": "MALDIVES",
  "hot": false
}, {
  "code": "MEX",
  "cnName": "墨西哥",
  "cnSpell": "MOXIGE",
  "enName": "MEXICO",
  "hot": false
}, {
  "code": "MHL",
  "cnName": "马绍尔群岛",
  "cnSpell": "MASHAOERQUNDAO",
  "enName": "MARSHALL ISLANDS",
  "hot": false
}, {
  "code": "MLI",
  "cnName": "马里",
  "cnSpell": "MALI",
  "enName": "MALI",
  "hot": false
}, {
  "code": "MMR",
  "cnName": "缅甸",
  "cnSpell": "MIANDIAN",
  "enName": "MYANMAR",
  "hot": false
}, {
  "code": "MNG",
  "cnName": "蒙古",
  "cnSpell": "MENGGU",
  "enName": "MONGOLIA",
  "hot": false
}, {
  "code": "MOZ",
  "cnName": "莫桑比克",
  "cnSpell": "MOSANGBIKE",
  "enName": "MOZAMBIQUE",
  "hot": false
}, {
  "code": "MRT",
  "cnName": "毛里塔尼亚",
  "cnSpell": "MAOLITANIYA",
  "enName": "MAURITANIA",
  "hot": false
}, {
  "code": "MUS",
  "cnName": "毛里求斯",
  "cnSpell": "MAOLIQIUSI",
  "enName": "MAURITIUS",
  "hot": false
}, {
  "code": "MWI",
  "cnName": "马拉维",
  "cnSpell": "MALAWEI",
  "enName": "MALAWI",
  "hot": false
}, {
  "code": "MYS",
  "cnName": "马来西亚",
  "cnSpell": "MALAIXIYA",
  "enName": "MALAYSIA",
  "hot": false
}, {
  "code": "MYT",
  "cnName": "马约特",
  "cnSpell": "MAYUETE",
  "enName": "MAYOTTE",
  "hot": false
}, {
  "code": "NAM",
  "cnName": "纳米比亚",
  "cnSpell": "NAMIBIYA",
  "enName": "NAMIBIA",
  "hot": false
}, {
  "code": "NCL",
  "cnName": "新喀里多尼亚",
  "cnSpell": "XINKALIDUONIYA",
  "enName": "NEW CALEDONIA",
  "hot": false
}, {
  "code": "NER",
  "cnName": "尼日尔",
  "cnSpell": "NIRIER",
  "enName": "NIGER",
  "hot": false
}, {
  "code": "NGA",
  "cnName": "尼日利亚",
  "cnSpell": "NIRILIYA",
  "enName": "NIGERIA",
  "hot": false
}, {
  "code": "NIC",
  "cnName": "尼加拉瓜",
  "cnSpell": "NIJIALAGUA",
  "enName": "NICARAGUA",
  "hot": false
}, {
  "code": "NLD",
  "cnName": "荷兰",
  "cnSpell": "HELAN",
  "enName": "NETHERLANDS",
  "hot": false
}, {
  "code": "NOR",
  "cnName": "挪威",
  "cnSpell": "NUOWEI",
  "enName": "NORWAY",
  "hot": false
}, {
  "code": "NPL",
  "cnName": "尼泊尔",
  "cnSpell": "NIBOER",
  "enName": "NEPAL",
  "hot": false
}, {
  "code": "NZL",
  "cnName": "新西兰",
  "cnSpell": "XINXILAN",
  "enName": "NEW ZEALAND",
  "hot": false
}, {
  "code": "OWN",
  "cnName": "阿曼",
  "cnSpell": "AMAN",
  "enName": "OMAN",
  "hot": false
}, {
  "code": "PAK",
  "cnName": "巴基斯坦",
  "cnSpell": "BAJISITAN",
  "enName": "PAKISTAN",
  "hot": false
}, {
  "code": "PAN",
  "cnName": "巴拿马",
  "cnSpell": "BANAMA",
  "enName": "PANAMA",
  "hot": false
}, {
  "code": "PCN",
  "cnName": "皮特凯恩群岛",
  "cnSpell": "PITEKAIENQUNDAO",
  "enName": "PITCAIRN ISLANDS",
  "hot": false
}, {
  "code": "PER",
  "cnName": "秘鲁",
  "cnSpell": "MILU",
  "enName": "PERU",
  "hot": false
}, {
  "code": "PHL",
  "cnName": "菲律宾",
  "cnSpell": "FEILVBIN",
  "enName": "PHILIPPINES",
  "hot": false
}, {
  "code": "PLW",
  "cnName": "帕劳",
  "cnSpell": "PALAO",
  "enName": "PALAU",
  "hot": false
}, {
  "code": "PNG",
  "cnName": "巴布亚新几内亚",
  "cnSpell": "BABUYAXINJINEIYA",
  "enName": "PAPUA NEW GUINEA",
  "hot": false
}, {
  "code": "POL",
  "cnName": "波兰",
  "cnSpell": "BOLAN",
  "enName": "POLAND",
  "hot": false
}, {
  "code": "PRI",
  "cnName": "波多黎各",
  "cnSpell": "BODUOLIGE",
  "enName": "PUERTO RICO",
  "hot": false
}, {
  "code": "PRK",
  "cnName": "朝鲜",
  "cnSpell": "CHAOXIAN",
  "enName": "NORTH KOREA",
  "hot": false
}, {
  "code": "PRT",
  "cnName": "葡萄牙",
  "cnSpell": "PUTAOYA",
  "enName": "PORTUGAL",
  "hot": false
}, {
  "code": "PRY",
  "cnName": "巴拉圭",
  "cnSpell": "BALAGUI",
  "enName": "PARAGUAY",
  "hot": false
}, {
  "code": "PST",
  "cnName": "巴勒斯坦",
  "cnSpell": "BALESITAN",
  "enName": "PALESTINE",
  "hot": false
}, {
  "code": "QAT",
  "cnName": "卡塔尔",
  "cnSpell": "KATAER",
  "enName": "QATAR",
  "hot": false
}, {
  "code": "ROM",
  "cnName": "罗马尼亚",
  "cnSpell": "LUOMANIYA",
  "enName": "ROMANIA",
  "hot": false
}, {
  "code": "RWA",
  "cnName": "卢旺达",
  "cnSpell": "LUWANGDA",
  "enName": "RWANDA",
  "hot": false
}, {
  "code": "SDN",
  "cnName": "苏丹",
  "cnSpell": "SUDAN",
  "enName": "SUDAN",
  "hot": false
}, {
  "code": "SEN",
  "cnName": "塞内加尔",
  "cnSpell": "SAINEIJIAER",
  "enName": "SENEGAL",
  "hot": false
}, {
  "code": "SGP",
  "cnName": "新加坡",
  "cnSpell": "XINJIAPO",
  "enName": "SINGAPORE",
  "hot": false
}, {
  "code": "SLB",
  "cnName": "所罗门群岛",
  "cnSpell": "SUOLUOMENQUNDAO",
  "enName": "SOLOMON ISLANDS",
  "hot": false
}, {
  "code": "SLV",
  "cnName": "萨尔瓦多",
  "cnSpell": "SAERWADUO",
  "enName": "EL SALVADOR",
  "hot": false
}, {
  "code": "SMR",
  "cnName": "圣马力诺",
  "cnSpell": "SHENGMALINUO",
  "enName": "SAN MARINO",
  "hot": false
}, {
  "code": "SOM",
  "cnName": "索马里",
  "cnSpell": "SUOMALI",
  "enName": "SOMALIA",
  "hot": false
}, {
  "code": "STP",
  "cnName": "圣多美和普林西比",
  "cnSpell": "SHENGDUOMEIHEPULINXIBI",
  "enName": "SAO TOME AND PRINCIPE",
  "hot": false
}, {
  "code": "SUR",
  "cnName": "苏里南",
  "cnSpell": "SULINAN",
  "enName": "SURINAME",
  "hot": false
}, {
  "code": "SVN",
  "cnName": "斯洛文尼亚",
  "cnSpell": "SILUOWENNIYA",
  "enName": "SLOVENIA",
  "hot": false
}, {
  "code": "SWE",
  "cnName": "瑞典",
  "cnSpell": "RUIDIAN",
  "enName": "SWEDEN",
  "hot": false
}, {
  "code": "SWZ",
  "cnName": "斯威士兰",
  "cnSpell": "SIWEISHILAN",
  "enName": "SWAZILAND",
  "hot": false
}, {
  "code": "SYC",
  "cnName": "塞舌尔",
  "cnSpell": "SAISHEER",
  "enName": "SEYCHELLES",
  "hot": false
}, {
  "code": "SYR",
  "cnName": "叙利亚",
  "cnSpell": "XULIYA",
  "enName": "SYRIA",
  "hot": false
}, {
  "code": "TCD",
  "cnName": "乍得",
  "cnSpell": "ZHADE",
  "enName": "CHAD",
  "hot": false
}, {
  "code": "TGO",
  "cnName": "多哥",
  "cnSpell": "DUOGE",
  "enName": "TOGO",
  "hot": false
}, {
  "code": "THA",
  "cnName": "泰国",
  "cnSpell": "TAIGUO",
  "enName": "THAILAND",
  "hot": false
}, {
  "code": "TJK",
  "cnName": "塔吉克斯坦",
  "cnSpell": "TAJIKESITAN",
  "enName": "TAJIKISTAN",
  "hot": false
}, {
  "code": "TKL",
  "cnName": "托克劳",
  "cnSpell": "TUOKELAO",
  "enName": "TOKELAU",
  "hot": false
}, {
  "code": "TKM",
  "cnName": "土库曼斯坦",
  "cnSpell": "TUKUMANSITAN",
  "enName": "TURKMENISTAN",
  "hot": false
}, {
  "code": "TMP",
  "cnName": "东帝汶",
  "cnSpell": "DONGDI汶",
  "enName": "EAST TIMOR",
  "hot": false
}, {
  "code": "TON",
  "cnName": "汤加",
  "cnSpell": "TANGJIA",
  "enName": "TONGA",
  "hot": false
}, {
  "code": "TTO",
  "cnName": "特立尼达和多巴哥",
  "cnSpell": "TELINIDAHEDUOBAGE",
  "enName": "TRINIDAD AND TOBAGO",
  "hot": false
}, {
  "code": "TUN",
  "cnName": "突尼斯",
  "cnSpell": "TUNISI",
  "enName": "TUNISIA",
  "hot": false
}, {
  "code": "TUR",
  "cnName": "土耳其",
  "cnSpell": "TUERQI",
  "enName": "TURKEY",
  "hot": true
}, {
  "code": "TUV",
  "cnName": "图瓦卢",
  "cnSpell": "TUWALU",
  "enName": "TUVALU",
  "hot": false
}, {
  "code": "TZA",
  "cnName": "坦桑尼亚",
  "cnSpell": "TANSANGNIYA",
  "enName": "TANZANIA",
  "hot": false
}, {
  "code": "UGA",
  "cnName": "乌干达",
  "cnSpell": "WUGANDA",
  "enName": "UGANDA",
  "hot": false
}, {
  "code": "UKR",
  "cnName": "乌克兰",
  "cnSpell": "WUKELAN",
  "enName": "UKRAINE",
  "hot": false
}, {
  "code": "URY",
  "cnName": "乌拉圭",
  "cnSpell": "WULAGUI",
  "enName": "URUGUAY",
  "hot": false
}, {
  "code": "USA",
  "cnName": "美国",
  "cnSpell": "MEIGUO",
  "enName": "UNITED STATES OF AMERICA",
  "hot": true
}, {
  "code": "UZB",
  "cnName": "乌兹别克斯坦",
  "cnSpell": "WUZIBIEKESITAN",
  "enName": "UZBEKISTAN",
  "hot": false
}, {
  "code": "VAT",
  "cnName": "梵蒂冈",
  "cnSpell": "FANDIGANG",
  "enName": "VATICAN CITY",
  "hot": false
}, {
  "code": "VEN",
  "cnName": "委内瑞拉",
  "cnSpell": "WEINEIRUILA",
  "enName": "VENEZUELA",
  "hot": false
}, {
  "code": "VGB",
  "cnName": "英属维尔京群岛",
  "cnSpell": "YINGSHUWEIERJINGQUNDAO",
  "enName": "VIRGIN ISLAND （GB）",
  "hot": false
}, {
  "code": "VIR",
  "cnName": "美属维尔京群岛",
  "cnSpell": "MEISHUWEIERJINGQUNDAO",
  "enName": "VIRGIN ISLAND （US）",
  "hot": false
}, {
  "code": "VNM",
  "cnName": "越南",
  "cnSpell": "YUENAN",
  "enName": "VIETNAM",
  "hot": false
}, {
  "code": "VUT",
  "cnName": "瓦努阿图",
  "cnSpell": "WANUATU",
  "enName": "VANUATU",
  "hot": false
}, {
  "code": "YUG",
  "cnName": "南斯拉夫",
  "cnSpell": "NANSILAFU",
  "enName": "YUGOSLAVIA",
  "hot": false
}, {
  "code": "ZAF",
  "cnName": "南非",
  "cnSpell": "NANFEI",
  "enName": "SOUTH AFRICA",
  "hot": true
}, {
  "code": "ZAR",
  "cnName": "扎伊尔",
  "cnSpell": "ZHAYIER",
  "enName": "ZAIRE",
  "hot": false
}, {
  "code": "ZMB",
  "cnName": "赞比亚",
  "cnSpell": "ZANBIYA",
  "enName": "ZAMBIA",
  "hot": false
}, {
  "code": "ZWE",
  "cnName": "津巴布韦",
  "cnSpell": "JINBABUWEI",
  "enName": "ZIMBABWE",
  "hot": false
}];

export default countryData;


//////////////////
// WEBPACK FOOTER
// ./src/components/preEntry/countryselect-data.js
// module id = 418
// module chunks = 2